module.exports = __webpack_public_path__ + "media/images/japan/steps_arrow-4e68c818e545afcb64a896158ed607d9.svg";